export enum BillingPricingType {
  BASE = 'BASE',
  PER_CHANNEL = 'PER_CHANNEL',
  PER_SEAT = 'PER_SEAT',
}

export enum BillingPlanInterval {
  MONTH = 'month',
  YEAR = 'year',
}

export enum BillingProductType {
  CHANNEL_OFFER = 'CHANNEL_OFFER',
}

export enum BillingSubscriptionStatus {
  ACTIVE = 'ACTIVE',
  PAST_DUE = 'PAST_DUE', // Require a customer action
  INCOMPLETE = 'INCOMPLETE', // Require a customer action
  CANCEL_REQUESTED = 'CANCEL_REQUESTED',
  CANCELED = 'CANCELED',
  UNPAID = 'UNPAID',
}

export enum BillingSubscriptionRequiredAction {
  PAYMENT_CONFIRMATION_REQUIRED = 'PAYMENT_CONFIRMATION_REQUIRED',
  PAYMENT_METHOD_REQUIRED = 'PAYMENT_METHOD_REQUIRED',
  WAIT_PAYMENT_PROCESSING = 'WAIT_PAYMENT_PROCESSING',
}
